// extracted by mini-css-extract-plugin
export default {"overlay":"TC-z","bodyOpen":"UC-z","content":"VC-z","header":"WC-z","close":"XC-z","closeNoHeading":"YC-z"};